var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"failed",attrs:{"id":"notification"}},[_c('div',[_c('div',{staticClass:"error-info"},[_vm._v(_vm._s(_vm.apiFailed))])])])}
var staticRenderFns = []

export { render, staticRenderFns }